import { apiPath } from '../../constants';
import { fetchCategoryOverview } from '../CategoryOverview';
import { fetchCompetitionCategories } from './listAction';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const CATEGORY_NOT_HELD_REQUEST = 'CATEGORY_NOT_HELD_REQUEST';
export const CATEGORY_NOT_HELD_SUCCESS = 'CATEGORY_NOT_HELD_SUCCESS';
export const CATEGORY_NOT_HELD_FAILURE = 'CATEGORY_NOT_HELD_FAILURE';

/**
 * «Категорія не проводилася» — and the way back from it.
 *
 * Both re-read the overview AND the category list afterwards, for the reason
 * confirmation learned the hard way (1 Oct 2026): the workspace on the right
 * and the list on the left read two different stores, and telling only one of
 * them leaves the list showing a mark the server no longer agrees with.
 * Nothing is flipped locally — `notHeld` and `resultsAwaitingConfirmation` are
 * the server's answers.
 */
export const markCategoryNotHeld = (competition, category, reason) => {
    return function(dispatch) {
        dispatch({ type: CATEGORY_NOT_HELD_REQUEST });
        return axios(apiRequestOptions(
            apiPath.COMPETITION_CATEGORY.NOT_HELD,
            { reason },
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CATEGORY_NOT_HELD_SUCCESS, competition, category, notHeld: true });
                dispatch(fetchCategoryOverview(competition, category));
                dispatch(fetchCompetitionCategories(competition));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CATEGORY_NOT_HELD_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};

export const clearCategoryNotHeld = (competition, category) => {
    return function(dispatch) {
        dispatch({ type: CATEGORY_NOT_HELD_REQUEST });
        return axios(apiRequestOptions(
            apiPath.COMPETITION_CATEGORY.NOT_HELD_CLEAR,
            null,
            { params: { competition, category } },
        ))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CATEGORY_NOT_HELD_SUCCESS, competition, category, notHeld: false });
                dispatch(fetchCategoryOverview(competition, category));
                dispatch(fetchCompetitionCategories(competition));
                return response.data;
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CATEGORY_NOT_HELD_FAILURE, error });
                dispatch(errorRequestHandler(error));
            });
    }
};
